import {
  Stack,
  Skeleton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@mui/material";

const ConversionSkeleton = () => {
  const rows = Array.from({ length: 14 });

  return (
    <Stack spacing={2}>
      {/* Filter Skeleton */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={1}
        mb={2}
      >
        {/* Autocomplete skeleton */}
        <Skeleton
          variant="rounded"
          height={36}
          sx={{ width: "70%", borderRadius: "8px" }}
        />

        {/* Download button skeleton */}
        <IconButton size="small" disabled>
          <Skeleton variant="circular" width={28} height={28} />
        </IconButton>
      </Stack>

      {/* Table Skeleton */}
      <Table size="small">
        <TableHead>
          <TableRow>
            {Array.from({ length: 3 }).map((_, i) => (
              <TableCell key={i}>
                <Skeleton width={80} height={16} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {/* Date cell */}
              <TableCell>
                <Skeleton width={70} height={16} />
              </TableCell>

              {/* FTD cell */}
              <TableCell>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Skeleton width={50} height={16} />
                  <Skeleton variant="rounded" width={40} height={20} />
                </Stack>
              </TableCell>

              {/* QFTD cell */}
              <TableCell>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Skeleton width={50} height={16} />
                  <Skeleton variant="rounded" width={40} height={20} />
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};

export default ConversionSkeleton;